module.exports = __webpack_public_path__ + "static/media/2262.9177b630.jpg";